import React from "react";
import { Button } from "@chakra-ui/react";
import { darken } from "@chakra-ui/theme-tools";

const CButton = ({
    fontSize = "sm",
    variant = "solid",
    fontWeight = "900",
    width = "100%",
    height = "40px",
    type = "button",
    color = "#ffff",
    bgColor = "#fa8f03",
    hoverBgColor = "#f9b64c",
    hoverColor = "#000000",
    borderRadius = "10px",
    children,
    ...props
}) => {
    const darkerHoverBgColor = darken(bgColor, 5);
    return (
        <Button
            fontSize={fontSize}
            variant={variant}
            fontWeight={fontWeight}
            w={width}
            h={height}
            type={type}
            color={color}
            bgColor={bgColor}
            borderRadius={borderRadius}
            _hover={{
                bgColor: darkerHoverBgColor,
            }}
            {...props}
        >
            {children}
        </Button>
    );
};

export default CButton;
